module.exports = __webpack_public_path__ + "img/add_insert_link_af.28ea1476.svg";